import { GameSizeMetrics } from 'src/games/common/phaser/game/scenes/scaled-base-scene';

export type GameLayoutConfig = {
  availableTextWidth: number;
  boardWidth: number;
  boardHeight: number;
  paddingXsm: number;
  paddingSm: number;
  paddingLg: number;
  paddingXlg: number;
  cardWidth: number;
  cardHeight: number;
  cardStackSpacing: number;
  columnWidth: number;
  columnHeight: number;
  columnSpacing: number;
  columnHintHeight: number;
  columnScoreHeight: number;
  nextCardOffsetX: number;
  nextCardOffsetY: number;
  nextCardAngle: number;
};

export type BoardScalingMetrics = {
  scaledOffsetX: number;
  scaleFactor: number;
};

export class GameMetricsService {
  public readonly gameLayoutConfig: GameLayoutConfig = {
    availableTextWidth: 256,
    boardWidth: 1200,
    boardHeight: 1600,
    paddingXsm: 15, // todo
    paddingSm: 25, // todo
    paddingLg: 50, // todo
    paddingXlg: 70, // todo
    cardWidth: 210,
    cardHeight: 315,
    cardStackSpacing: 70, // todo
    columnWidth: 230,
    columnHeight: 1120,
    columnSpacing: 30,
    columnHintHeight: 125,
    columnScoreHeight: 165,
    nextCardOffsetX: 60,
    nextCardOffsetY: 5,
    nextCardAngle: 8,
  };

  public static defaultBoardScalingMetrics(): BoardScalingMetrics {
    return {
      scaledOffsetX: 0,
      scaleFactor: 1,
    };
  }

  public calculateBoardScaling(gameSizeMetrics: GameSizeMetrics): BoardScalingMetrics {
    const layoutConfig = this.gameLayoutConfig;
    const totalWidth = layoutConfig.boardWidth;
    const totalHeight = layoutConfig.boardHeight;

    const scaleFactorW = gameSizeMetrics.widthDpr / totalWidth;
    const scaleFactorH = gameSizeMetrics.heightDpr / totalHeight;

    let scaledOffsetX = 0;
    if (scaleFactorH < scaleFactorW) {
      scaledOffsetX = (totalWidth * scaleFactorW - totalWidth * scaleFactorH) * 0.5;
    }

    return {
      scaledOffsetX: scaledOffsetX,
      scaleFactor: Math.min(scaleFactorW, scaleFactorH),
    };
  }
}
